'use strict';

var isPropertyDescriptor = require('./records/property-descriptor');
module.exports = function isFullyPopulatedPropertyDescriptor(ES, Desc) {
  return isPropertyDescriptor(Desc) && typeof Desc === 'object' && '[[Enumerable]]' in Desc && '[[Configurable]]' in Desc && (ES.IsAccessorDescriptor(Desc) || ES.IsDataDescriptor(Desc));
};